import {isBlank} from "@/utils/validate";


export function distinct<T extends Record<any, any>>(arr: T[], key: string):T[] {
    let set: any = {}
    let narr:T[] = []
    for (let e of arr) {
        if (set[e[key]]) {
            continue
        }
        set[e[key]] = true
        narr.push(e)
    }
    return narr
}

export function toDate(timestamp: any): Date | null {
    if (timestamp instanceof Date) {
        return timestamp
    }

    if (typeof timestamp === "number") {
        return new Date(timestamp)
    }

    return null
}

export function toInt(v: any): Number | null {

    if (typeof v === "number") {
        return v
    }

    if (typeof v === "string") {
        try {
            return parseInt(v)
        } catch (e) {
            return null
        }

    }

    return null
}


export function split(ids: string | null): string[] {
    if (!(typeof ids == "string") || isBlank(ids)) {
        return []
    }
    ids = ids.replace(/ /g,"")
    ids = ids.replace(/，/g,"")
    let arr = ids.split(",")
    return arr
}


export function renderLatex(content: string) {
    // 存在html格式转化
    if (content.includes('<')) {
        const template = `<div class='list'>${content}</div>`
        const doc = new DOMParser().parseFromString(template, 'text/html')
        const $elem = doc.querySelectorAll('.list')[0]
        const kfformula = $elem.querySelectorAll('strong')
        const pEle = $elem.querySelectorAll('p')
        // eslint-disable-next-line no-plusplus
        for (let index = 0; index < pEle.length; index++) {
            const p = pEle[index]
            //@ts-ignore
            p.style.margin = 0
        }
        // eslint-disable-next-line no-plusplus
        for (let a = 0; a < kfformula.length; a++) {
            const element = kfformula[a]
            if (element.innerHTML.includes('img')) {
                // eslint-disable-next-line no-plusplus
                //@ts-ignore
                for (let index = 0; index < element.childNodes.length; index++) {
                    const elementChild = element.childNodes[index]
                    if (elementChild.nodeType === 3) {
                        const span = document.createElement('span')
                        //@ts-ignore
                        span.innerHTML = elementChild.valueOf().data
                        span.className = 'latex-render'
                        element.replaceChild(span, elementChild)
                        const latex = element.querySelector('.latex-render')
                        try {
                            // eslint-disable-next-line no-undef
                            //@ts-ignore
                            katex.render(latex.innerHTML, latex)
                        } catch (error) {
                            return content
                        }
                    }
                }
            } else {
                try {
                    // eslint-disable-next-line no-undef
                    // @ts-ignore
                    katex.render(element.innerText, element)
                } catch (error) {
                    return content
                }
            }
        }
        return $elem.innerHTML
    }
    return content
}